import { rms } from "./lib/voice";

let mic: { ctx: AudioContext; analyser: AnalyserNode; stream: MediaStream; buf: Float32Array<ArrayBuffer> } | null = null;

export async function enableMic() {
  if (mic) return true;
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: { echoCancellation: true, noiseSuppression: true, autoGainControl: true },
    });
    const ctx = new AudioContext();
    const analyser = ctx.createAnalyser();
    analyser.fftSize = 1024;
    ctx.createMediaStreamSource(stream).connect(analyser);
    mic = { ctx, analyser, stream, buf: new Float32Array(analyser.fftSize) };
    return true;
  } catch {
    return false;
  }
}

export function disableMic() {
  mic?.stream.getTracks().forEach((t) => t.stop());
  mic?.ctx.close().catch(() => {});
  mic = null;
}

export const resumeMic = () => mic?.ctx.resume().catch(() => {});

export function micLevel() {
  if (!mic) return null;
  mic.analyser.getFloatTimeDomainData(mic.buf);
  return rms(mic.buf);
}
